import { render, staticRenderFns } from "./BreakoutRoomsActions.vue?vue&type=template&id=3f876ee8&scoped=true"
import script from "./BreakoutRoomsActions.vue?vue&type=script&lang=js"
export * from "./BreakoutRoomsActions.vue?vue&type=script&lang=js"
import style0 from "./BreakoutRoomsActions.vue?vue&type=style&index=0&id=3f876ee8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f876ee8",
  null
  
)

export default component.exports